import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
    Grid,
    Chip,
    CircularProgress
} from '@mui/material';

export default function OrderSummary({ order, isLoading }) {
    const positions = order.orderPositions;
    const getStatusDescription = (status) => {
        switch (status) {
            case '1':
                return 'Ausstehend';
            case '2':
                return 'Wird zubereitet';
            case '3':
                return order.deliveryOption === '0' ? 'Unterwegs' : 'Abholbereit';
            case '4':
                return 'Lieferproblem';
            case '5':
                return 'Geliefert';
            case '6':
                return 'Storniert';
            default:
                return '';
        }
    }
    const formatDateTime = (str) =>
        str ? new Date(str).toLocaleString('de-DE', {day:"2-digit", month:"2-digit", year:"numeric", hour: "2-digit", minute:"2-digit", second:"2-digit"}) : '—';

    const fullAddress = `${order.street} ${order.houseNumber}, ${order.zip} ${order.city}`;

    return (
        <Card
            sx={{
                width: "100%",
                height: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column"
            }}
        >
            <CardContent
                sx={{
                    flex: "1 1 auto",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <Typography variant="h5" gutterBottom>
                    Bestellung #{order.id} – {order.shopName}
                </Typography>

                <Typography variant="body1">
                    <strong>Bestellt von:</strong> {order.fullname}
                </Typography>
                <Typography variant="body2">{fullAddress}</Typography>
                <Typography variant="body2">
                    <strong>Zahlungsart:</strong> {order.paymentMethod || 'Unbekannt'}
                </Typography>
                <Typography variant="body2">
                    <strong>Lieferoption:</strong> {order.deliveryOption === '1' ? 'Lieferung' : 'Abholung'}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6">Bestellte Artikel:</Typography>

                <Box
                    sx={{
                        flex: "1 1 auto",
                        overflowY: "auto",
                        pr: 1,
                        mt: 1,
                    }}
                >
                    {positions?.map((item, index) => (
                        <Box key={index} sx={{ mb: 1 }}>
                            <Grid container justifyContent="space-between">
                                <Grid item xs={8}>
                                    <Typography variant="body1">
                                        {item.quantity}× {item.name}
                                        {item.isDiscount ? (
                                            <Chip
                                                label={`${item.discountPercent}% Rabatt`}
                                                size="small"
                                                color="success"
                                                sx={{ ml: 1 }}
                                            />
                                        ) : null}
                                    </Typography>
                                    {item.note && (
                                        <Typography variant="body2" color="text.secondary">
                                            Notiz: {item.note}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={4} textAlign="right">
                                    <Typography variant="body1">
                                        {item.price.toFixed(2).replace(".", ",")} €
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ mt: "auto" }}>
                    <Typography variant="body2">
                        <strong>Vorbereitungsbeginn:</strong> {formatDateTime(order.prepStart)}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Lieferstart:</strong> {formatDateTime(order.deliveryStart)}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Status:</strong> {getStatusDescription(order.status)}
                    </Typography>
                </Box>

                {isLoading && (
                    <div style={{
                        position: "absolute",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        top: 0,
                        left: 0,
                        background: "rgba(0,0,0,0.4)",
                        width: "100%",
                        height: "100%",
                        zIndex: 1
                    }}>
                        <CircularProgress sx={{ color: 'white' }} />
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
